var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tabs',{attrs:{"content-class":"mt-3"}},[_c('b-tab',{attrs:{"title":"Listas de Checkeo","active":""}},[_c('app-supervision-checklist')],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Pareto Indicadores"}},[_c('app-supervision-indicators')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }